import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { IdentitySecurityService } from 'src/app/services/identitySecurity';
import { ToastService } from 'src/app/services/toast.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-enable-authenticator-app-dialog',
  templateUrl: './enable-authenticator-app-dialog.component.html'
})
export class EnableAuthenticatorAppDialogComponent implements OnInit {
  @Input('step') step!: number;
  @Input('userId') userId!: string;
  translations = <any>{};
  authenticatorData!: any;
  recoveryCodes!: any;

  constructor(public activeModal: NgbActiveModal, private securityService: IdentitySecurityService, private toastService: ToastService, private translateService: TranslateService) {
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  getTranslations() {
    this.translateService.get([
      'Toasts.ClipboardNotSupported',
      'Toasts.ClipboardError',
      'Toasts.PasswordValidationSomethingWrong',
      'Toasts.ErrorFetchingQR',
      'Toasts.InvalidTwoFAKey',
      'Toasts.ErrorFetchingRecoveryCodes',
      'Toasts.Error'
    ]).subscribe(translation => {
      this.translations.toastsClipboardError = translation['Toasts.ClipboardError'];
      this.translations.toastsClipboardNotSupported = translation['Toasts.ClipboardNotSupported'];
      this.translations.toastsPasswordValidationSomethingWrong = translation['Toasts.PasswordValidationSomethingWrong'];
      this.translations.toastsErrorFetchingQR = translation['Toasts.ErrorFetchingQR'];
      this.translations.toastsInvalidTwoFAKey = translation['Toasts.InvalidTwoFAKey'];
      this.translations.toastsErrorFetchingRecoveryCodes = translation['Toasts.ErrorFetchingRecoveryCodes'];
      this.translations.error = translation['Toasts.Error'];
    });
  }

  checkPassword(password: string) {
    this.securityService.checkPassword(this.userId, password)
      .then(value => {
        lastValueFrom(value)
          .then(() => {
            this.getEnableAuthenticatorQR();
            this.step = 2;
          })
          .catch(() => this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsPasswordValidationSomethingWrong + ""));
      })
      .catch(() => this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsPasswordValidationSomethingWrong + ""));
  }

  check2FactorCode(code: string) {
    this.authenticatorData.code = code;
    this.securityService.enableAuthenticator(this.userId, this.authenticatorData)
      .then(value => {
        lastValueFrom(value)
        .then(() => {
          this.securityService.generateRecoveryCodes(this.userId)
            .then(val => {
              lastValueFrom(val)
                .then((data: any) => {
                  this.recoveryCodes = JSON.stringify(data.recoveryCodes);
                  let re1 = /\["/gi;
                  let re2 = /\","/gi;
                  let re3 = /\"]/gi;
                  this.recoveryCodes = this.recoveryCodes.replace(re1, '').replace(re2, ' ').replace(re3, '');
                  this.step = 3;
                })
                .catch(() => this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsErrorFetchingRecoveryCodes + ""));
            })
            .catch(() => this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsErrorFetchingRecoveryCodes + ""));
        })
        .catch(() => this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsInvalidTwoFAKey + ""));
      })
      .catch(() => this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsInvalidTwoFAKey + ""));
  }
  

  getEnableAuthenticatorQR() {
    this.securityService.enableAuthenticatorQR(this.userId)
      .then(value => {
        lastValueFrom(value)
          .then((data: any) => {
            this.authenticatorData = data})
          .catch(() =>  this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsErrorFetchingQR + ""));
      })
      .catch(() =>  this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsErrorFetchingQR + ""));
  }

  async copyRecoveryCodesToClipboard(){
    try{
    if (!navigator.clipboard) {
      this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsClipboardNotSupported + "");
    }
    await navigator.clipboard.writeText(this.recoveryCodes);
   }
   catch (error: any) {
     this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsClipboardError + "");
   }
  }

  async copySecretToClipboard() {
    try{
      if (!navigator.clipboard) {
        this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsClipboardNotSupported + "");
      }
      await navigator.clipboard.writeText(this.authenticatorData.sharedKey);
     }
     catch (error: any) {
       this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsClipboardError + "");
     }
  }

  async close(){
    this.activeModal.close();
  }

}
